import { styled } from "styled-components";

import { ArrowRight } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

const IconWrapper = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    opacity: 0;
    transition:
        box-shadow 0.2s ease-in-out,
        background 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 0 0 8px ${colorsPalettes.carbon[50]};
        background: ${colorsPalettes.carbon[50]};
    }

    [data-card-hovered="true"] & {
        opacity: 1;
    }
`;

export interface IArrowProps {
    tooltip: string;
}

export const Arrow = ({ tooltip }: IArrowProps) => (
    <Tooltip content={tooltip}>
        <IconWrapper>
            <ArrowRight
                size={16}
                color={colorsPalettes.blue[400]}
            />
        </IconWrapper>
    </Tooltip>
);
